module.exports = __webpack_public_path__ + "static/media/icon_menu_report.75c929c1.svg";